import { render } from "./PointStatus.vue?vue&type=template&id=1c54557c"
import script from "./PointStatus.vue?vue&type=script&lang=js"
export * from "./PointStatus.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__